import React, {useState, useContext, useRef} from 'react';
import { IonContent, IonText, IonHeader, IonTitle, IonToolbar, IonItem, IonList, IonMenuButton, IonButton, IonButtons, IonInput, IonModal, IonGrid, IonRow, IonCol, IonSlides, IonSlide } from '@ionic/react';

import { EnterPasswordModal } from './Modal_EnterPassword';
import { Auth_Zasava_Context } from '../../../storeState/Auth_Zasava_Context';

export function GrantEmployeeAccessModal (props) {

    let authenticated_Zasava_Context = useContext(Auth_Zasava_Context);

    const [acctID, setAcctID] = useState(authenticated_Zasava_Context.acctID);
    const [schema, setSchemaName] = useState(authenticated_Zasava_Context.schema);
    let [sessionID, setSessionID ] = useState(authenticated_Zasava_Context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticated_Zasava_Context.baseURL);

    let [globalEmployeeID, setGlobalEmployeeID] = useState(null);
    let [viewEmployeeDetailsData, setViewEmployeeDetailsData] = useState([]);
    let [inventoryAccessCheckboxValue, setInventoryAccessCheckboxValue] = useState(null);
    let [employeeManagementAccessCheckboxValue, setEmployeeManagementAccessCheckboxValue] = useState(null);
    let [checkInCheckOutAccessCheckboxValue, setCheckInCheckOutAccessCheckboxValue] = useState(null);
    let [cleaningServicesAccessCheckboxValue, setCleaningServicesAccessCheckboxValue] = useState(null);
    let [employeeID, setEmployeeID] = useState(null);
    let [showPasswordModal, setShowPasswordModal] = useState(false)
    let [enteredPassword, setEnteredPassword] = useState('');

    function handleInventoryAccessCheckbox(e) 
    { 
        let checkbox = document.getElementById('inventoryAccess');

        if(checkbox.checked === true)
        {
            setInventoryAccessCheckboxValue('Y'); 
        }
        else{

            setInventoryAccessCheckboxValue('n'); 
        }

    }
    function handleEmployeeManagementAccessCheckbox(e) 
    { 
        let checkbox = document.getElementById('employeeManagementAccess');

        if(checkbox.checked === true)
        {
            setEmployeeManagementAccessCheckboxValue('Y');
        }
        else{

            setEmployeeManagementAccessCheckboxValue('N');
        }
    }
    function handleCheckInCheckOutAccessCheckbox(e) 
    { 
        let checkbox = document.getElementById('checkInCheckOutAccess');

        if(checkbox.checked === true)
        {
            setCheckInCheckOutAccessCheckboxValue('Y');  
        }
        else{

            setCheckInCheckOutAccessCheckboxValue('N');  
        }
    }
    function handleCleaningServicesAccessCheckbox(e) 
    { 
        let checkbox = document.getElementById('cleaningServicesAccess');

        if(checkbox.checked === true)
        {
            setCleaningServicesAccessCheckboxValue('Y');
        }
        else{

            setCleaningServicesAccessCheckboxValue('N');
        }
    }

    function saveEmployeeAccessSetting() 
    {
        /*let formData = new FormData();
        formData.append('Tracker', 74501);
        formData.append('user', acctID);
        formData.append('xEmployeeID', employeeID);
        formData.append('xInventoryAccessValue', inventoryAccessCheckboxValue);
        formData.append('xEmployeeManagementAccessValue', employeeManagementAccessCheckboxValue);
        formData.append('xCheckInCheckOutAccessValue', checkInCheckOutAccessCheckboxValue);
        formData.append('xCleaningServicesAccessValue', cleaningServicesAccessCheckboxValue);
        formData.append('xEnterAdminPassword', enteredPassword);

        const requestOptions = {
            enctype: 'multipart/form-data',
            method:'POST',
            credentials: 'include',
            body: formData,
        }
        */

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '74501',
                user: acctID,
                xEmployeeID: employeeID,
                xInventoryAccessValue: inventoryAccessCheckboxValue,
                xEmployeeManagementAccessValue: employeeManagementAccessCheckboxValue,
                xCheckInCheckOutAccessValue: checkInCheckOutAccessCheckboxValue,
                xCleaningServicesAccessValue: cleaningServicesAccessCheckboxValue,
                xEnterAdminPassword: enteredPassword,
                sessionID: sessionID,

            }),
        }

        fetch(baseURL+'zsava_internal_indexApp', requestOptions)
        .then(res => res.text())
        .then(data => {

            alert(data);
        })
        .catch(error => {
            console.error(error);
        })

    }

    function searchEmployeeList(searchCategory)
    {
        //alert('In Search Employee List');
        //alert(searchCategory);

        let searchData = document.getElementById('searchEmployee').value;
        let optionsData = document.getElementById('searchEmployeeList').childNodes;

        for (let i = 0; i < optionsData.length; ++i)
        {
            
            if(optionsData[i].text === searchData)
            {
                employeeSearchResults(optionsData[i].dataset.id);
                break;
            }

            else if (i === optionsData.length - 1)
            {
                if (searchData.length > 1)
                {
                    searchEmployeeInDB(searchCategory, searchData, optionsData);
                }
                else if (searchData.length === 0)
                {
                    let optionsData = document.getElementById('searchEmployeeList').childNodes;

                    for (let i = 0; i < optionsData.length; ++i)
                    {
                        let remove = document.getElementsByClassName('forRemoveProjectSearch');

                        while(remove.length > 0)
                        {
                            remove[0].parentNode.removeChild(remove[0]);
                        }
                    }

                    break;
                }
                else
                {
                    first_searchEmployeeInDB(searchCategory, searchData, optionsData);
                }
            }
        }
    }

    function first_searchEmployeeInDB(searchCategory, searchData, optionsData)
    {

        /*
        let formData = new FormData();
        formData.append('Tracker', 74502);
        formData.append('user', acctID);
        formData.append('xSearchEmployee', searchData);


        const requestOptions = {
            method: 'POST',
            credentials: 'include',
            body: formData
        }
        */

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '74502',
                user: acctID,
                xSearchEmployee: searchData,
                sessionID: sessionID,

            }),
        }
        
        fetch(baseURL+'zsava_internal_indexApp', requestOptions)
        .then(res => res.text())
        .then(res => {
        
                        let rows = res.toString().split('~~~');

                        let rowLength = rows.length;

                            for (let rownum = 0; rownum < rowLength - 1; ++rownum)
                            {
                                let cols = rows[rownum].split('|');

                               // document.getElementById('searchEmployeeList').insertAdjacentHTML('beforeend', '<option class=\'forRemoveProjectSearch\' data-id=\''+cols[0]+'\' onclick=\'employeeSearchResults('+cols[0]+', '+cols[2]+', '+cols[3]+', '+cols[4]+', '+cols[5]+')\'>'+cols[1]+'</option>');
                               document.getElementById('searchEmployeeList').insertAdjacentHTML('beforeend', '<option class=\'forRemoveProjectSearch\' data-id=\''+[cols[0], cols[1], cols[3], cols[4], cols[5], cols[6], searchCategory,]+'\'>'+cols[2]+'</option>'); // onclick=\'employeeSearchResults(`'+cols[1]+'`, `'+cols[3]+'`, `'+cols[4]+'`, `'+cols[5]+'`, `'+cols[6]+'`)\'
                               //document.getElementById('searchEmployeeList').insertAdjacentHTML('beforeend', '<option class=\'forRemoveProjectSearch\' data-zero=\''+[cols[0]+'\' data-two=\''+[cols[2]+'\' data-three=\''+[cols[3]+'\' data-four=\''+[cols[4]+'\' data-five=\''+[cols[5]+'\' data-six=\''+[cols[6]+'\'>'+cols[2]+'</option>'); // onclick=\'employeeSearchResults(`'+cols[1]+'`, `'+cols[3]+'`, `'+cols[4]+'`, `'+cols[5]+'`, `'+cols[6]+'`)\'

                            }
                    })
        }

    function searchEmployeeInDB(searchCategory, searchData, optionsData)
    {
        //let searchData = document.getElementById('searchEmployee').value;
        //let optionsData = document.getElementById('searchEmployeeList').childNodes;


        /*
        let formData = new FormData();
        formData.append('Tracker', 74502);
        formData.append('user', acctID);
        formData.append('xSearchEmployee', searchData);


        const requestOptions = {
            method: 'POST',
            credentials: 'include',
            body: formData
        }
        */

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '74502',
                user: acctID,
                xSearchEmployee: searchData,
                sessionID: sessionID,

            }),
        }
        
        fetch(baseURL+'zsava_internal_indexApp', requestOptions)
        .then(res => res.text())
        .then(res => {

                        let rows = res.toString().split('~~~');
                        let rowLength = rows.length;

                            for (let rownum = 0; rownum < rowLength - 1; ++rownum)
                            {
                                let cols = rows[rownum].split('|');

                                for (let i = 0; i < optionsData.length; ++i)
                                {
                                    if (optionsData[i].dataset.id === cols[0])
                                    {
                                        optionsData[i].className = 'forDontRemoveProjectSearch';
                                        continue;
                                    }
                                    else if (i === (optionsData.length - 1) && optionsData[i].dataset.id != cols[0])
                                    {
                                        document.getElementById('searchEmployeeList').insertAdjacentHTML('beforeend', '<option class=\'forRemoveProjectSearch\' data-id=\''+[cols[0], cols[1], cols[3], cols[4], cols[5], cols[6], searchCategory,]+'\'>'+cols[2]+'</option>'); //onclick=\'employeeSearchResults(`'+cols[1]+'`, `'+cols[3]+'`, `'+cols[4]+'`, `'+cols[5]+'`, `'+cols[6]+'`)\'
                                    }
                                }
                            }

                            for (let i = 0; i < optionsData.length; ++i)
                            {
                                let remove = document.getElementsByClassName('forRemoveProjectSearch');

                                while(remove.length > 0)
                                {
                                    remove[0].parentNode.removeChild(remove[0]);
                                }
                            }
                    })
        }

    function employeeSearchResults(searchResults)
    {
       let event = searchResults.split(',');
        //alert('EmployeeSearchResults');
        //alert(event[0]);
        //alert(event[1]);

        setGlobalEmployeeID(event[0]);
        setEmployeeID(event[1]);
        setInventoryAccessCheckboxValue(event[2]);
        setEmployeeManagementAccessCheckboxValue(event[3]);
        setCheckInCheckOutAccessCheckboxValue(event[4]);
        setCleaningServicesAccessCheckboxValue(event[5]);


        if(event[6] === 'se1')
        {
            //alert('event[6] === se1');

            if(event[2] === 'y')
            {
                document.getElementById('inventoryAccess').checked = true;
            }
            if(event[3] === 'y')
            {
                document.getElementById('employeeManagementAccess').checked = true;
            }
            if(event[4] === 'y')
            {
                document.getElementById('checkInCheckOutAccess').checked = true;
            }        
            if(event[5] === 'y')
            {
                document.getElementById('cleaningServicesAccess').checked = true;
            }
        }
        else if(event[6] === 'se2')
        {
            setViewEmployeeDetailsData([]);

            getEmployeeDetailData(event[1]);   
            document.getElementById('deleteEmployeeGrid').style.display = 'inline-block';
        } 


    }



    function getEmployeeDetailData(employeeID) {

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: 74504,
                user: acctID,
                xEmployeeID: employeeID,
                sessionID: sessionID,
            }),
        }
        
        
        fetch(baseURL+'zsava_internal_indexApp', requestOptions)
        .then(res => res.text())
        .then(res => {

            let rows = res.toString().split('~~~');

            for (let rownum = 0; rownum < rows.length - 1; ++rownum)
            {
                let cols = rows[rownum].split('|');

                setViewEmployeeDetailsData((prevViewEmployeeDetailsData) => {
                    return prevViewEmployeeDetailsData.concat({
                        employeeID: cols[0],
                        employeeFirstName: cols[1],
                        employeeLastName: cols[2],
                        dateHired: cols[6],
                        biWeeklyPay: cols[7],
                        jobFunction: cols[8],
                        phoneNumber: cols[9],
                        emailAddress: cols[10],
                        employeeSchema: cols[14],
                    })
                });

            } 
        })
    }

    function onSubmitPasswordHandler(event)
    {
        setEnteredPassword(event);
        saveEmployeeAccessSetting();
    }

    function closeModalHandler() {

        props.closeModal(false);
    }
    
    return (
        <React.Fragment>
        {props.openModal == true ?
        (
        <IonModal isOpen={ props.openModal }>
        <IonSlides pager='true'>
            <IonSlide>
                <IonItem>
                    {/*<IonLabel>Search Item: </IonLabel>
                    <IonInput placeholder='Search Item' onIonChange={handleSearchInventoryItem }></IonInput>*/}
                        <label for='searchEmployee'>Search Employees:</label>
                        <input type='text' id='searchEmployee' placeholder='Search Employee List' onInput={() => searchEmployeeList('se1')} list='searchEmployeeList' required></input>
                        <datalist id='searchEmployeeList'>
                            <option value='0'> None </option>
                        </datalist>
                </IonItem>
                <IonItem> 
                <h1>Grant Access</h1>
                <form id='fileUpload' enctype='multipart/form-data'>
                    <label for='inventoryAccess'> Inventory Management Access </label>
                        <input type='checkbox' id='inventoryAccess' onChange={(e) => handleInventoryAccessCheckbox(e)}></input>
                    <label for='employeeManagementAccess'>Employee Management Access</label>
                        <input type='checkbox' id='employeeManagementAccess' onChange={(e) => handleEmployeeManagementAccessCheckbox(e)}></input>
                    <label for='checkInCheckOutAccess'>Check_In/Check_Out Access</label>
                        <input type='checkbox' id='checkInCheckOutAccess' onChange={(e) => handleCheckInCheckOutAccessCheckbox(e)}></input>
                    <label for='cleaningServicesAccess'>Cleaning Services</label>
                        <input type='checkbox' id='cleaningServicesAccess' onChange={(e) => handleCleaningServicesAccessCheckbox(e)}></input>
                    {/*<input type="button" value="upload" onClick={uplodFile} ></input>*/}
                </form>
                </IonItem>

                <IonButton onClick={() => setShowPasswordModal(true)}> Save Access Settings </IonButton>

                <EnterPasswordModal openModal={ showPasswordModal } closeModal={() => setShowPasswordModal(false)} onSubmitPassword={ onSubmitPasswordHandler }></EnterPasswordModal>

            </IonSlide>
        </IonSlides>
        <IonButton onClick={() => closeModalHandler(false)}>Cancel </IonButton>
        </IonModal>) : null}
    </React.Fragment>
    )
}